import { createValidator, rules } from "@lchemy/model/validation";

import { Application } from "./application";
import { UserStatus } from "./enums";
import { AccessGroup } from "./rbac";
import { UserToken } from "./user-token";

export interface User {
  id?: number;
  name: string;
  email: string;
  status: UserStatus;
  tokens?: UserToken[];

  groups?: AccessGroup[];
  applications?: Application[];
}

export const userEmailValidator = createValidator<Pick<User, "email">>({
  email: [rules.required(), rules.isString(), rules.isEmail()]
});

export const updateUserValidator = createValidator<User>({
  id: [rules.required(), rules.isInt()],
  name: [rules.required(), rules.isString(), rules.minLength(1)],
  groups: [
    rules.required(),
    rules.each([
      rules.required(),
      rules.model<AccessGroup>({
        id: [rules.required(), rules.isInt()]
      })
    ])
  ]
});
